import { render, staticRenderFns } from "./SlideProduct.vue?vue&type=template&id=f17f467e&scoped=true"
import script from "./SlideProduct.vue?vue&type=script&lang=js"
export * from "./SlideProduct.vue?vue&type=script&lang=js"
import style0 from "./SlideProduct.vue?vue&type=style&index=0&id=f17f467e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17f467e",
  null
  
)

export default component.exports